import TextLoader from './TextLoader';

export default TextLoader;
